import axios from 'axios';
import axiosRetry from 'axios-retry';
import appSettings from '@/app-settings.json';

export const apiClient = axios.create({
  baseURL: appSettings.apiDomain,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 29000, // 29 seconds; this value is driven by AWS API Gateway integration timeout.
});

axiosRetry(apiClient, {
  retries: 5,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: axiosRetry.isNetworkOrIdempotentRequestError,
});
